import { render, staticRenderFns } from "./ExamTitle.vue?vue&type=template&id=586db742&scoped=true&"
import script from "./ExamTitle.vue?vue&type=script&lang=js&"
export * from "./ExamTitle.vue?vue&type=script&lang=js&"
import style0 from "./ExamTitle.vue?vue&type=style&index=0&id=586db742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586db742",
  null
  
)

component.options.__file = "ExamTitle.vue"
export default component.exports